import { ref, watch } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
export default function usePropertyPinTagsList() {
    const toast = useToast()
    const tagsData = ref([])
    const isLoading = ref(false)
    const searchQuery = ref('')

    const fetchData = () => {
        isLoading.value = true
        store
        .dispatch('app-property-pin-tags/fetchData', {
          perpage: 1000,
          offset: 0,
          keyword: searchQuery.value,
          order_by: 'ORDERING_COUNT ASC',
        })
        .then(response => {
         tagsData.value = response.data.data
        })
        .catch(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: "Error fetching property pin tags' list",
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
        .finally(() => {
          isLoading.value = false
        })
      }
      const refetchData = () => {
        fetchData()
      }
      watch(searchQuery, () => {
        refetchData()
      })
      const deleteData = (id) => {
        store.dispatch('app-property-pin-tags/fetchDelete',id).then(response=>{
          toast({
            component: ToastificationContent,
            props: {
              title: "Delete Success",
              icon: 'AlertTriangleIcon',
              variant: 'success',
            },
          })
          refetchData();
        }).catch(()=>{
          toast({
            component: ToastificationContent,
            props: {
              title: "Error Delete Property Pin Tag",
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
      }
      const updateActive = (item, is_active) => {
        const payload = { ...item, is_active: is_active ? 1 : 0 }
        store.dispatch('app-property-pin-tags/fetchUpdate', payload).then(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: "Update Active Success",
              icon: 'AlertTriangleIcon',
              variant: 'success',
            },
          })
          refetchData();
        }).catch(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: "Error Update Active",
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
      }
      const updateOrdering = () => {
        store.dispatch('app-property-pin-tags/updateOrdering', tagsData.value).then(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: "Reorder Success",
              icon: 'AlertTriangleIcon',
              variant: 'success',
            },
          })
        }).catch(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: "Error Reordering Property Pin Tags",
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
          refetchData();
        })
      }
    return {
      fetchData,
      tagsData,
      isLoading,
      searchQuery,
      deleteData,
      refetchData,
      updateActive,
      updateOrdering,
    }
}
